module.exports = __webpack_public_path__ + "img/search.4e2fe956.svg";